{
  "version": 1,
  "asset_id": "73345658-1625-4f09-9b11-6ac1ec47a5ae",
  "project_id": "f3267492-75a1-4be6-8d94-522819be8b81",
  "url": "/__l5e/assets-v1/73345658-1625-4f09-9b11-6ac1ec47a5ae/katie-fernands.webp",
  "r2_key": "a/v1/f3267492-75a1-4be6-8d94-522819be8b81/73345658-1625-4f09-9b11-6ac1ec47a5ae/katie-fernands.webp",
  "original_filename": "katie-fernands.webp",
  "size": 7946,
  "content_type": "image/webp",
  "created_at": "2026-07-17T17:22:06Z"
}
